import { css } from 'glamor'

export default {
  result: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    textAlign: 'center',

    '@media(min-width: 700px)': {
      padding: '30px 0',
      boxSizing: 'border-box',
    },
  }),
  share: css({
    width: '50px',
    margin: '0 15px',
    cursor: 'pointer',
  }),
  image: css({
    maxHeight: '200px',
  }),
  scoreLabel: css({
    color: '#bbb',
  }),
  score: css({
    margin: '10px 0',
    fontSize: '50px',
  }),
  sharedBlock: css({
    marginBottom: '10px',
  }),
  sharingTitle: css({
    marginBottom: '5px',
  }),
}



// WEBPACK FOOTER //
// ./src/components/Result/styles.js